// Check 'Mobile device detection' at https://developer.mozilla.org/en-US/docs/Web/HTTP/Browser_detection_using_the_user_agent
export function getIsMobileClient() {
  let hasTouchScreen = false
  if ('maxTouchPoints' in navigator) {
    hasTouchScreen = navigator.maxTouchPoints > 0
  } else if ('msMaxTouchPoints' in navigator) {
    hasTouchScreen = window.navigator.msMaxTouchPoints
      ? window.navigator.msMaxTouchPoints > 0
      : false
  } else {
    const mQ = window.matchMedia('(pointer:coarse)')
    if (mQ.media === '(pointer:coarse)') {
      hasTouchScreen = !!mQ.matches
    } else if ('orientation' in window) {
      hasTouchScreen = true // deprecated, but good fallback
    } else {
      // Only as a last resort, fall back to user agent sniffing
      const UA = navigator.userAgent
      hasTouchScreen =
        // explanation for `\b` https://shareg.pt/mqUSu8v
        /\b(Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Windows Phone|Mobile|Tablet)\b/i.test(
          UA,
        )
    }
  }

  return hasTouchScreen
}
